export enum AccessibilityKey {
    ENTER = 'Enter',
    SPACEBAR = ' ',
}